import AxiosConfig from '@/config/axios-config'

export const ProfessorAPI = {

  listar (pagina = null, filtro = []) {
    return AxiosConfig.jalekoAPI().get('/admin/professores', {
      params: {
        page: pagina,
        professor: filtro.professor,
        atividade: filtro.atividade,
        criado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
        criado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : ''
      }
    }).then(response => response.data)
  },

  cadastrar (professor) {
    let formData = new FormData()
    for (var key in professor) {
      if (professor[key] === null) {
        professor[key] = ''
      }
      formData.append(key, professor[key])
    }
    return AxiosConfig.jalekoAPI().post('/admin/professores', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    ).then(response => response.data)
  },

  deletar (id) {
    return AxiosConfig.jalekoAPI().delete('/admin/professores/' + id + '/deletar'
    ).then(response => response.data)
  },

  editar (professor, id) {
    let formData = new FormData()
    for (var key in professor) {
      if (professor[key] === null) {
        professor[key] = ''
      }
      formData.append(key, professor[key])
    }
    return AxiosConfig.jalekoAPI().post('/admin/professores/' + id, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    ).then(response => response.data)
  }

}

export default ProfessorAPI
